var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInformationSmall = function SvgInformationSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.75-11.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M6.75 7a.5.5 0 0 0 0 1h1v3h-1a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-1V7.5a.5.5 0 0 0-.5-.5z",
    clipRule: "evenodd"
  })));
};
export default SvgInformationSmall;